export class ProxyDto {
  enabled?: boolean;
  host: string;
  port: string;
  protocol: string;
  username?: string;
  password?: string;
}
